import { TeaserCaseWideComponent } from 'components';
import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import { Grid } from 'style';
import { DataStoreService } from 'utils';

class FrontCaseList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      cases: null,
    };
  }

  componentDidMount() {
    this.setState(() => ({
      cases: DataStoreService.getCases(),
    }));
  }

  render() {
    const { cases } = this.state;
    return cases ? (
      <FrontCaseListWrapper id="FrontCaseList">
        <Grid.Container>
          {cases.edges.map(data => (
            <Grid.RowCenter key={data.node.slug}>
              <TeaserCaseWideComponent
                {...{
                  title: data.node.teaserTitle,
                  image: data.node.teaserImageWide,
                  slug: data.node.slug,
                }}
              />
            </Grid.RowCenter>
          ))}
        </Grid.Container>
      </FrontCaseListWrapper>
    ) : (
        <div />
      );
  }
}

const FrontCaseListWrapper = styled.div`
    padding: 30px 0;
`;

export default FrontCaseList;
